import NominationIcon1 from "../../assets/images/nominationImg1.svg";
import NominationIcon2 from "../../assets/images/nominationImg2.svg";
import NominationIcon3 from "../../assets/images/nominationImg3.svg";

import ResearchPublishingImg1 from "../../assets/images/ResearchPublisingImg1.svg";
import ResearchPublishingImg2 from "../../assets/images/ResearchPublisingImg2.svg";
import ResearchPublishingImg3 from "../../assets/images/ResearchPublisingImg3.svg";

export const aboutAwardsData = [
  {
    img: NominationIcon1,
    title: "Excellence",
    desc: "Recognizing exceptional performance, innovation, and contributions that set new standards in academic achievement.",
    id: 1,
  },
  {
    img: NominationIcon2,
    title: "Impact",
    desc: "Celebrating measurable contributions to knowledge advancement, student success, and societal transformatio",
    id: 2,
  },
  {
    img: NominationIcon3,
    title: "Innovation",
    desc: "Honoring creative approaches, technological integration, and pioneering methods in education and research.",
    id: 3,
  },
];

export const ResearchPublisingData = [
  {
    img: ResearchPublishingImg1,
    title: "Best Research Paper",
    desc: "Innovation, methodology, relevance, and significant scholarly contribution to the field.",
    id: 1,
  },
  {
    img: ResearchPublishingImg2,
    title: "Best Young Researcher",
    desc: "Promising early-career contributions to research by academics under 40 years of age.",
    id: 2,
  },
  {
    img: ResearchPublishingImg3,
    title: "Best Publisher",
    desc: "Ethical publishing practices, high-impact dissemination, and academic integrity.",
    id: 3,
  },
];
